<div class="row acc-logo" [ngClass]="borderClass">
  <div
    (click)="trigger()"
    (mouseenter)="mouseenterFun()"
    (mouseleave)="mouseleaveFun()"
    class="col-xs-12 pointer"
    [ngClass]="[expand ? 'line-bord-show' : 'line-bord-2']">
    <div class="row title-bar">
      <div class="l-mr-3 icon-container">
        @if (expand) {
        <cds-icon [width]="size" [height]="size" [ngClass]="_iconClass" [config]="_config" [icon]="upIcon"></cds-icon>
        } @if (!expand) {
        <cds-icon [ngClass]="_iconClass" [width]="size" [height]="size" [config]="_config" [icon]="downIcon"></cds-icon>
        }
      </div>
      <div class="col-xs l-plr-0">
        @if (headerTpl) {
        <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
        }
      </div>
    </div>
  </div>

  <div [@openClose]="_detaiClass" class="col-xs-12 row line-bord-detail" [ngClass]="borderNone">
    <ng-content></ng-content>
  </div>
</div>
